export default function ApplicationLogo({ className }) {
    return (
    <img className={className} src={"/assets/img/dadij.png"} alt={"logo application"}/>
    );
}
